import PropTypes from "prop-types";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { Chip, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useState, useMemo } from "react";
import "./TasksListMain.scss";

const TasksListSpecial = ({ taskRecord, onNameClick, activeName }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Get unique categories from all records
  const allCategories = useMemo(() => {
    const categoriesSet = new Set();
    taskRecord?.forEach(record => {
      record.employeeSpecialCategory?.forEach(category => {
        categoriesSet.add(category);
      });
    });
    const categories = Array.from(categoriesSet);
    // Set the first category as default if there are categories and no selection
    if (categories.length > 0 && selectedCategory === null) {
      setSelectedCategory(categories[0]);
    }
    return categories;
  }, [taskRecord, selectedCategory]);

  console.log("taskRecord:", taskRecord);

  // Sort records by turnCount and status
  const sortedRecords = (records) =>
    [...records].sort((a, b) => {
      if (a.status === "" && b.status !== "") return -1;
      if (a.status !== "" && b.status === "") return 1;
      return a.turnCount - b.turnCount;
    });

  // Get all records that have the selected category and calculate turnCount
  const getFilteredRecords = () => {
    if (!selectedCategory || !taskRecord) return [];
    
    const filtered = taskRecord
      .map((record) => {
        let turnCount = 0;
        // Calculate turnCount from t1 to t20
        Array.from({ length: 20 }).forEach((_, i) => {
          const key = `t${i + 1}`;
          const categoriesArray = record[key]?.serSpecialCategory;
          if (Array.isArray(categoriesArray)) {
            categoriesArray.forEach((cat) => {
              if (cat === selectedCategory) {
                turnCount += 1;
              }
            });
          }
        });

        // Return record only if there's a matching category
        if (record.employeeSpecialCategory?.includes(selectedCategory)) {
          return { ...record, turnCount };
        }
        return null;
      })
      .filter((record) => record !== null);

    return sortedRecords(filtered);
  };

  const handleRowClick = (name) => {
    onNameClick(name);
  };

  const renderStatus = (status) => {
    if (status?.includes("working")) {
      return (
        <span className="status-busy">
          Busy <AccessTimeOutlinedIcon className="status-icon" />
        </span>
      );
    } else if (status?.includes("break")) {
      return (
        <span className="status-break">
          Break <AccessTimeOutlinedIcon className="status-icon" />
        </span>
      );
    }
    return null;
  };

  const filteredRecords = getFilteredRecords();

  return (
    <div className="tasks-list-container">
      {/* Category buttons */}
      {allCategories.length > 0 ? (
        <div className="button-group-container" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "10px" }}>
          <ToggleButtonGroup
            value={selectedCategory}
            exclusive
            onChange={(event, newValue) => {
              if (newValue !== null) {
                setSelectedCategory(newValue);
              }
            }}
            style={{ display: "inline-flex" }}
            sx={{
              "& .MuiToggleButton-root": {
                border: "none",
                borderRadius: "4px",
                margin: "0 4px",
                "&:first-of-type": {
                  marginLeft: 0,
                },
                "&:last-of-type": {
                  marginRight: 0,
                },
              },
            }}
          >
            {allCategories.map((category) => (
              <ToggleButton
                key={category}
                value={category}
                sx={{
                  fontSize: "12px",
                  padding: "4px 8px",
                  minWidth: "50px",
                  height: "24px",
                  backgroundColor: "#ffffff",
                  border: "1px solid #e0e0e0",
                  color: "black",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "black !important",
                    color: "white !important",
                    border: "none",
                    "&:hover": {
                      backgroundColor: "#333333 !important",
                    },
                  },
                }}
              >
                {category}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </div>
      ) : (
        <div>No special categories available.</div>
      )}

      {/* Records list */}
      <div className="content">
          <table className="tasks-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Turn</th>
                <th>Status</th>
                <th>Notify</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((record, index) => (
                <tr
                  key={index}
                  className={record.name === activeName ? "row-active" : ""}
                  onClick={() => handleRowClick(record.name)}
                >
                  <td className="name-cell">{record.name}</td>
                  <td className="turn-cell">
                    <Chip
                      label={record.turnCount}
                      sx={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        padding: "0px",
                        backgroundColor: "rgba(45, 191, 224, 0.36)", // Blue with 20% opacity
                      }}
                    />
                  </td>
                  <td className="status-cell">{renderStatus(record.status)}</td>
                  <td className="notify-cell">{record.notify} ...</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
    </div>
  );
};

TasksListSpecial.propTypes = {
  taskRecord: PropTypes.array.isRequired,
  onNameClick: PropTypes.func.isRequired,
  activeName: PropTypes.string,
};

export default TasksListSpecial;